import { render, staticRenderFns } from "./VuesticTabs.vue?vue&type=template&id=660311a0&"
import script from "./VuesticTabs.vue?vue&type=script&lang=js&"
export * from "./VuesticTabs.vue?vue&type=script&lang=js&"
import style0 from "./VuesticTabs.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "VuesticTabs.vue"
export default component.exports